import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isOnboardingPatient } from 'utils/userTypeHelper';
import { onboardingStatuses } from 'constants/patient_statuses';
import PatientStatus from '../patientsStatusReport/table/status';

const ActivityRow = ({ patient }) => (
  <tr className="acitivity-row">
    <td data-label="GUID">{patient.guid}</td>
    <td data-label="MRN">{patient.mrn}</td>
    <td data-label="Full Name" className="patient-name">
      {isOnboardingPatient(onboardingStatuses, patient.status) ? (
        <strong>{patient.patientName}</strong>
      ) : (
        <Link to={`/patient/${patient.guid}`}>
          <strong>{patient.patientName}</strong>
        </Link>
      )}
    </td>
    <td data-label="DOB">{patient.birthDate}</td>
    <td data-label="Primary phone">{patient.phone}</td>
    <td data-label="Secondary phone">{patient.homeNumber}</td>
    <td data-label="Preferred contact method">
      {patient.preferredContactMethod}
    </td>
    <PatientStatus status={patient.status} />
    <td
      data-label="Interaction status"
      style={{
        backgroundColor: patient.interactionStatus ? '#84E075' : '#a60303',
        color: '#fff',
      }}
    >
      {patient.interactionStatus ? 'True' : 'False'}
    </td>
    <td data-label="Interaction Status Change Date">
      {patient.interactionStatusChangedDate}
    </td>
    <td data-label="Clinic Name">{patient.clinicName}</td>
    <td data-label="Clinic Guid">{patient.clinicGuid}</td>
    <td data-label="Doctor Name">{patient.doctorName} </td>
    <td data-label="Doctor Guid">{patient.doctorGuid}</td>
  </tr>
);

ActivityRow.propTypes = {
  patient: PropTypes.object,
};

export default ActivityRow;
